// What the pages tell a person when an action they confirm with a passkey,
// such as a runner's code, was not taken (store.ts,
// `ConfirmedOutcome`): the same words whatever the action, but for a failure
// of any other kind, which the page's own words lead.
import { noPasskeysText } from '../api/passkeys'
import type { ConfirmedOutcome } from '../store/store'

/** What to tell the person when the action was not taken; `failed` leads the words of any other failure. */
export function confirmationProblemText(outcome: Extract<ConfirmedOutcome<unknown>, { ok: false }>, failed: string): string {
  switch (outcome.problem) {
    case 'refused':
      return 'The passkey was refused. Try again.'
    case 'cancelled':
      return 'The passkey prompt was cancelled.'
    case 'unsupported':
      return noPasskeysText()
    case 'identity_changed':
      return 'Who is signed in changed. Try again.'
    case 'failed':
      return `${failed}: ${outcome.message}`
  }
}
